export type RankRequirementsPrintFilters = {
  vesselId: string;
  rankId: string | number;
};

export type RankRequirementsByNationalityPrintFilters = {
  vesselId: string;
  nationalityId: string | number;
};

const PAGE_BASE = '/crew/certificate-requirements';

export function rankRequirementsPrintPath(filters: RankRequirementsPrintFilters): string {
  const qs = new URLSearchParams({
    vesselId: String(filters.vesselId),
    rankId: String(filters.rankId),
  });
  return `${PAGE_BASE}/print?${qs.toString()}`;
}

export function rankRequirementsByNationalityPrintPath(
  filters: RankRequirementsByNationalityPrintFilters,
): string {
  const qs = new URLSearchParams({
    vesselId: String(filters.vesselId),
    nationalityId: String(filters.nationalityId),
  });
  return `${PAGE_BASE}/print/by-nationality?${qs.toString()}`;
}

export function rankRequirementsListApiUrl(params: URLSearchParams): string | null {
  const vesselId = params.get('vesselId')?.trim();
  const rankId = params.get('rankId')?.trim();
  if (!vesselId || !rankId) return null;
  return `/crew/rank-requirements?rankId=${encodeURIComponent(rankId)}&vesselId=${encodeURIComponent(vesselId)}&exactVessel=1`;
}

/** All vessel requirements (every rank) for exact vessel scope. */
export function rankRequirementsVesselApiUrl(params: URLSearchParams): string | null {
  const vesselId = params.get('vesselId')?.trim();
  if (!vesselId) return null;
  return `/crew/rank-requirements?vesselId=${encodeURIComponent(vesselId)}&exactVessel=1`;
}

export function rankRequirementsBackPath(params: URLSearchParams): string {
  const vesselId = params.get('vesselId')?.trim();
  if (!vesselId) return PAGE_BASE;
  return `${PAGE_BASE}?vesselId=${encodeURIComponent(vesselId)}`;
}
